"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Card = require("../Card");

var _Form = _interopRequireDefault(require("../Form"));

var _Button = _interopRequireDefault(require("../Button"));

var _config = require("../config/config");

var CardForm =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(CardForm, _Component);

  function CardForm() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CardForm);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CardForm)).call.apply(_getPrototypeOf2, [this].concat(_args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      changed: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "dismiss", function (e) {
      e && e.preventDefault();
      _this.props.onClose && _this.props.onClose(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onChange", function () {
      var _this$props;

      _this.setState({
        changed: true
      });

      _this.props.onChange && (_this$props = _this.props).onChange.apply(_this$props, arguments);
    });
    return _this;
  }

  (0, _createClass2.default)(CardForm, [{
    key: "isNeedConfirmation",
    value: function isNeedConfirmation() {
      var confirmOnDismiss = this.props.confirmOnDismiss;
      return confirmOnDismiss && this.state.changed;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          header = _this$props2.header,
          onClose = _this$props2.onClose,
          className = _this$props2.className,
          children = _this$props2.children,
          submitLabel = _this$props2.submitLabel,
          dissmissLabel = _this$props2.dissmissLabel,
          showDismiss = _this$props2.showDismiss,
          wide = _this$props2.wide,
          editable = _this$props2.editable,
          props = (0, _objectWithoutProperties2.default)(_this$props2, ["header", "onClose", "className", "children", "submitLabel", "dissmissLabel", "showDismiss", "wide", "editable"]);
      delete props.confirmOnDismiss;
      return _react.default.createElement(_Form.default, (0, _extends2.default)({}, props, {
        onChange: this.onChange,
        className: (0, _classnames.default)('card', className, {
          'card--wide': wide === true,
          'card--wide-2': wide === 2,
          'card--wide-3': wide === 3
        })
      }), onClose && _react.default.createElement(_Card.CardClose, {
        confirmOnDismiss: this.isNeedConfirmation(),
        onClick: onClose
      }), header && _react.default.createElement(_Card.CardHeader, null, header), _react.default.createElement(_Card.CardContent, null, children), _react.default.createElement(_Card.CardActions, null, onClose && showDismiss && _react.default.createElement(_Button.default, {
        borderless: true,
        shortcut: "esc",
        onClick: this.dismiss,
        confirmOnDismiss: this.isNeedConfirmation()
      }, dissmissLabel || (0, _config.__)('Dismiss')), editable && _react.default.createElement(_Button.default, {
        primary: true,
        disabled: props.isLoading,
        type: "submit"
      }, submitLabel || (0, _config.__)('Save'))));
    }
  }]);
  return CardForm;
}(_react.Component);

exports.default = CardForm;
(0, _defineProperty2.default)(CardForm, "defaultProps", {
  editable: true,
  showDismiss: true,
  confirmOnDismiss: false
});
CardForm.propTypes = process.env.NODE_ENV !== "production" ? {
  wide: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf([2, 3])]),
  className: _propTypes.default.string,
  header: _propTypes.default.node,
  isLoading: _propTypes.default.bool,
  editable: _propTypes.default.bool,
  showDismiss: _propTypes.default.bool,
  submitLabel: _propTypes.default.string,
  dissmissLabel: _propTypes.default.string,
  onSubmit: _propTypes.default.func.isRequired,
  onClose: _propTypes.default.func,
  confirmOnDismiss: _propTypes.default.bool
} : {};